import SettingsEmptyState from '../../components/settings/SettingsEmptyState';
import React, { useEffect, useState } from 'react'
import { useInvoice, usePut, useCurrent } from '../../hooks/'
import { MwButton, MwSpinnerButton } from '../../components/ui'
import { useDispatch } from 'react-redux'
import { updateSettings } from '../../store/settingSlice'
import SettingListItem from '../../components/settings/SettingListItem'
import { useTranslation } from 'react-i18next'

const CENTRAL_SETTINGS_SCOPE = 'global';

const PurchasesQuoteSettings = ({ refreshTenant, filterDefineSetting }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation('global');
    const { SETTING_QUOTE } = useInvoice()
    const [quoteSetting, setQuoteSetting] = useState(SETTING_QUOTE)
    const { data, loading, putData } = usePut()
    const { currentCompanyId, currentTenantId, currentLangId, currentSettings } = useCurrent();

    const quoteSettingArray = Object.entries(quoteSetting || {});
    const quoteSettingList = quoteSettingArray.map(([settingName, settingValue]) => (
        <SettingListItem
            key={settingName}
            settingName={settingName}
            settingValue={settingValue}
            filterDefineSetting={filterDefineSetting}
            setGeneralSetting={setQuoteSetting}
            generalSetting={quoteSetting}
            currentLangId={currentLangId}
            prefixLang='invoice'
        />
    ));

    useEffect(() => {
        if (data) {
            refreshTenant();
        }
    }, [data, refreshTenant]);

    useEffect(() => {
        if (SETTING_QUOTE) {
            setQuoteSetting(SETTING_QUOTE);
        }
    }, [SETTING_QUOTE]);

    const saveHandler = async () => {
        if (!quoteSetting) return;
        try {
            const payload = {
                tenantId: currentTenantId,
                companyId: currentCompanyId,
                scope: CENTRAL_SETTINGS_SCOPE,
                data: {
                    invoiceSettings: currentSettings?.invoiceSettings || {},
                    generalSettings: currentSettings?.generalSettings || {},
                    quoteSettings: quoteSetting
                }
            };
            await putData(`${process.env.REACT_APP_Auth_API_BASE_URL}/settings/central`, payload)
            dispatch(updateSettings({
                typeSetting: 'quote',
                value: quoteSetting
            }));
        } catch (err) {
            console.error('Failed to save purchases quote settings:', err);
        }
    }

    if (quoteSettingArray.length === 0) {
        return <SettingsEmptyState title={t('setting.quoteSettings')} />;
    }

    return (
        <div className="settings-editable-page">
            <div className='flex justify-between items-center mb-6'>
                <h1 className="text-2xl font-bold text-gray-800">{t("setting.quoteSettings")}</h1>
                {loading ? <MwSpinnerButton /> : <MwButton
                    inGroup={true}
                    size='sm'
                    onClick={saveHandler}
                    type='saveBtn'
                >
                    {t("setting.saveChanges")}
                </MwButton>}
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
                {quoteSettingList}
            </div>
        </div>
    )
}

export default PurchasesQuoteSettings
